module.exports = __webpack_public_path__ + "static/media/bg-light-1.b52cb599.png";